import Vue from 'vue'
import VueRouter from 'vue-router'

import { isAuthenticated } from '@/services/auth'

Vue.use(VueRouter)

const Login = () => import(/* webpackChunkName: "view-login" */ '@/views/LoginView.vue')
const Home = () => import(/* webpackChunkName: "view-home" */ '@/views/PlatformHome.vue')

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'LoginView',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/home',
    name: 'PlatformHome',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const authenticated = isAuthenticated()
  
  if (to.meta.requiresAuth && !authenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router
